import axios from "axios";
import { timeGroupsType, timeType } from "types";

const groupTimes = async (times: timeType[]): Promise<timeGroupsType[]> => {
  const groupTimes: timeGroupsType[] = [];

  for (let i = 0; i < times.length; i++) {
    let time = times[i];

    const [bizIDCode, eventIDCode] = time.perfID.split(".");
    const eventCode = `${bizIDCode}.${eventIDCode}`;

    const index = groupTimes.findIndex((obj) => obj.code == eventCode);

    if (index === -1) {
      const performanceInfo = await axios.get(`/api/readperformance?performanceid=${time.perfID}`);
      groupTimes.push({
        code: eventCode,
        name: performanceInfo.data.response.PERFORMANCE.NAME._text,
        error: "",
        times: [time],
      });
    } else {
      groupTimes[index].times = [...groupTimes[index].times, time];
    }
  }

  return groupTimes;
};

export default groupTimes;
